
import { Component, Mixins, Ref } from "vue-property-decorator";
import mixin from "./mixin";
import { getModule } from "vuex-module-decorators";
import { OrderModule, SystemModule } from "@/store/modules";
import * as modals from "@/lib/modals";
import notifications from "@/lib/notifications";

const systemModule = getModule(SystemModule);
const orderModule = getModule(OrderModule);

interface DefaultRemarks {
  id: string | number;
  type: string;
  text: string;
}

interface DefaultDriverNote {
  id: string | number;
  type: string;
  text: string;
}

@Component({
  name: modals.updateOrderInstructionsModal
})
export default class UpdateOrderInstructionsModal extends Mixins(mixin) {
  defaultRemarks: string = "";
  defaultDriverNote: string = "";
  localRemarks: string = "";
  localDriverNote: string = "";
  appendInstructions: string = "append";

  saving: boolean = false;

  @Ref() readonly remarksBody!: HTMLInputElement;
  @Ref() readonly driverNoteBody!: HTMLInputElement;

  get existingInstructions() {
    return !!this.localRemarks || !!this.localDriverNote;
  }

  get modalData() {
    return systemModule.modalData.selectedItems;
  }

  get isMultipleOrders() {
    return systemModule.modalData?.selectedItems && (systemModule.modalData?.selectedItems.length > 1);
  }

  get existingInstructionsOrderHeaderNumber() {
    if (this.modalData.length === 1) {
      return this.modalData[0].headerNumber;
    }
    return null;
  }
  
  created() {
    this.localRemarks = JSON.parse(JSON.stringify(this.defaultRemarks));
    this.localDriverNote = JSON.parse(JSON.stringify(this.defaultDriverNote));
  }

  resetModal() {
    this.localRemarks = JSON.parse(JSON.stringify(this.defaultRemarks));
    this.localDriverNote = JSON.parse(JSON.stringify(this.defaultDriverNote));
  }

  onShown() {
    this.appendInstructions = "append";
    this.show();
    if (this.modalData.length === 1) {
      if (this.modalData[0].remarks) {
        let existingRemarks = this.modalData[0].remarks;
        this.localRemarks = existingRemarks;
      }
      if (this.modalData[0].driverNote) {
        let existingDriverNote = this.modalData[0].driverNote;
        this.localDriverNote = existingDriverNote;
      }
    }
    this.remarksBody.focus();
  }

  async saveInstructions() {
    this.saving = true;
    const remark = this.localRemarks ?? "" ;
    const driverNote = this.localDriverNote ?? "" ;
    try {
      for (const modalItem of this.modalData) {
        await orderModule.updateOrderRemarks({
          headerNumber: modalItem.headerNumber,
          remarks: this.appendInstructions === "append" && this.isMultipleOrders && modalItem.remarks ? `${modalItem.remarks} ${remark}` : remark
        });
        await orderModule.updateOrderDriverNote({
          headerNumber: modalItem.headerNumber,
          driverNote: this.appendInstructions === "append" && this.isMultipleOrders && modalItem.driverNote ? `${modalItem.driverNote} ${driverNote}` : driverNote
        });
      }
      notifications.success("Update Order Instructions", "Order Instructions successfully updated.");
      await this.refreshOrders();
      this.hideModal();
    } catch (ex) {
      notifications.error("Update Order Instructions", "Failed to update order instructions", ex);
    }
    this.saving = false;
    this.hideModal();
  }
}
